/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { CurrentWizardStepFragment } from '../../../../common/configurable-wizards/queries/queryTyping/current-wizard-step';
import { gql } from '@apollo/client';
import { CurrentWizardStepFragmentDoc } from '../../../../common/configurable-wizards/queries/queryTyping/current-wizard-step';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetUserKindStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserKindStepQuery = (
  { __typename?: 'Query' }
  & { userKindStep: Types.Maybe<(
    { __typename?: 'CurrentWizardStep' }
    & CurrentWizardStepFragment
  )> }
);


export const GetUserKindStepDocument = gql`
    query GetUserKindStep {
  userKindStep {
    ...CurrentWizardStep
  }
}
    ${CurrentWizardStepFragmentDoc}`;

/**
 * __useGetUserKindStepQuery__
 *
 * To run a query within a React component, call `useGetUserKindStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserKindStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserKindStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserKindStepQuery(baseOptions?: Apollo.QueryHookOptions<GetUserKindStepQuery, GetUserKindStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserKindStepQuery, GetUserKindStepQueryVariables>(GetUserKindStepDocument, options);
      }
export function useGetUserKindStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserKindStepQuery, GetUserKindStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserKindStepQuery, GetUserKindStepQueryVariables>(GetUserKindStepDocument, options);
        }
export type GetUserKindStepQueryHookResult = ReturnType<typeof useGetUserKindStepQuery>;
export type GetUserKindStepLazyQueryHookResult = ReturnType<typeof useGetUserKindStepLazyQuery>;
export type GetUserKindStepQueryResult = Apollo.QueryResult<GetUserKindStepQuery, GetUserKindStepQueryVariables>;